import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import Vue from 'vue'
import VueStash from 'vue-stash'
import VueResource from 'vue-resource'
import Stores from './components/Stores/Stores.vue'
import store from './store/stores'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { mapEdges, hasNextPage } from './utils/Apollo'
import VueApollo from 'vue-apollo'
import BootstrapVue from 'bootstrap-vue'
import Utils from './components/Utils/stores'
import vSelect from 'vue-select'
import { formatIsoDate } from './utils/DateFormat'
import { formatPhone } from './utils/FormatPhone'
import { getQuery, getMutation, isLogged } from './graphql/utils'
import BootstrapVueOptions from './utils/BootstrapVueOptions'

if (window.isProduction) {
    Sentry.init({
        dsn: `https://cf090de51e8f4401ab6a332f4d450a59@o468496.ingest.sentry.io/5496419`,
        integrations: [
            new Integrations.BrowserTracing(),
            new VueIntegration({
                Vue,
                tracing: true,
            }),
        ],
    })
}

if (!window.fetch) {
    window.fetch = (
        require(`unfetch`).default || require(`unfetch`)
    )
}

const storesSelector = `#stores`
const storesElement = document.querySelector(storesSelector)
let StoresVueStore = null

if (storesElement) {
    Utils.install(Vue)
    Vue.use(VueStash)
    Vue.use(VueResource)
    Vue.use(BootstrapVue, BootstrapVueOptions)
    Vue.component('v-select', vSelect)
    Vue.directive('shadow', (el, depth) => {
        const classes = ['shadow', 'shadow-sm', 'shadow-lg']

        classes.forEach(c => {
            el.classList.remove(c)
        })

        if (depth.value === 1) {
            el.classList.add(`shadow-sm`)
        } else if (depth.value === 2) {
            el.classList.add(`shadow`)
        } else if (depth.value === 3) {
            el.classList.add(`shadow-lg`)
        } else {
            el.classList.add(`shadow-sm`)
        }
    })

    Vue.prototype.formatIsoDate = formatIsoDate
    Vue.prototype.mapEdges = mapEdges
    Vue.prototype.getQuery = getQuery
    Vue.prototype.getMutation = getMutation
    Vue.prototype.isLogged = isLogged
    Vue.prototype.formatPhone = formatPhone
    Vue.prototype.hasNextPage = hasNextPage

    Vue.http.options.emulateJSON = true

    const cache = new InMemoryCache()

    const httpLink = new HttpLink({
        uri : `${window.location.origin}/graphql`,
        credentials: 'same-origin',
    })


    const apolloClient = new ApolloClient({
        cache,
        link: httpLink,
        connectToDevTools : true,
        defaultOptions: {
            fetchPolicy: 'no-cache',
        },
    })

    Vue.use(VueApollo)

    const apolloProvider = new VueApollo({
        defaultClient: apolloClient,
    })

    StoresVueStore = new Vue({
        name    : 'Stores',
        el      : storesSelector,
        render  : h => h(Stores),
        apolloProvider,
        data    : { store },
    })

}

export default StoresVueStore
